export default __webpack_public_path__ + "static/media/17.fde45c6f.png";